export default {
  Carrier: 1,
  Forwarder: 2,
  Shipper: 3,
  Dispatcher: 4,
  ForwarderCarrier: 5,
  ShipperCarrier: 6,
};
